var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07873 0H2.64011C1.188 0 0 1.188 0 2.64011V8.07873C0 9.53084 1.188 10.7188 2.64011 10.7188H8.07873C9.53084 10.7188 10.7188 9.53084 10.7188 8.07873V2.64011C10.7188 1.188 9.53084 0 8.07873 0ZM9.66289 8.07873C9.66289 8.94997 8.95002 9.66289 8.07873 9.66289H2.64011C1.76887 9.66289 1.05595 8.95002 1.05595 8.07873V2.64011C1.05595 1.76887 1.76883 1.05595 2.64011 1.05595H8.07873C8.94997 1.05595 9.66289 1.76883 9.66289 2.64011V8.07873Z",
    fill: "#8B8CFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.36 14.9441H7.92136C7.05012 14.9441 6.3372 14.2313 6.3372 13.36V12.304H5.28125V13.36C5.28125 14.8121 6.46925 16.0001 7.92136 16.0001H13.36C14.8121 16.0001 16.0001 14.8121 16.0001 13.36V7.92136C16.0001 6.46925 14.8121 5.28125 13.36 5.28125H12.304V6.3372H13.36C14.2312 6.3372 14.9441 7.05008 14.9441 7.92136V13.36C14.9441 14.2312 14.2313 14.9441 13.36 14.9441Z",
    fill: "#8B8CFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.7664ab8db29f1ca174bcb25b28882425.svg";
export { ForwardRef as ReactComponent };